// install (please try to align the version of installed @nivo packages)
// yarn add @nivo/sankey
import { ResponsiveSankey } from '@nivo/sankey'

// make sure parent container have a defined height when using
// responsive component, otherwise height will be 0 and
// no chart will be rendered.
// website examples showcase many properties,
// you'll often use just a few of them.
const NivoSankeyChart = ({ data, legend=false, paddingLeft=100, paddingRight=100,
                         thickness=8, spacing=6}) => {
    const legendConfig = [];
    if (legend){
        legendConfig.push({
            anchor: 'bottom-right',
            direction: 'column',
            translateX: 130,
            itemWidth: 100,
            itemHeight: 14,
            itemDirection: 'right-to-left',
            itemsSpacing: 2,
            itemTextColor: '#999',
            symbolSize: 14,
            symbolShape: 'square',
            effects: [
                {
                    on: 'hover',
                    style: {
                        itemTextColor: '#000'
                    }
                }
            ]
        });
    }
    return (
        <ResponsiveSankey
            data={data}
            margin={{ top: 40, right: paddingRight, bottom: 40, left: paddingLeft }}
            align="justify"
            colors={{ scheme: 'paired' }}
            nodeOpacity={1}
            nodeHoverOthersOpacity={1}
            nodeThickness={thickness}
            nodeSpacing={spacing}
            nodeBorderWidth={0}
            nodeBorderColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        0.8
                    ]
                ]
            }}
            nodeBorderRadius={3}
            linkOpacity={0.5}
            linkHoverOpacity={1}
            linkHoverOthersOpacity={0.1}
            linkContract={3}
            enableLinkGradient={true}
            labelPosition="outside"
            labelOrientation="horizontal"
            labelPadding={16}
            animate={false}
            labelTextColor={{
                from: 'color',
                modifiers: [
                    [
                        'darker',
                        1
                    ]
                ]
            }}
            legends={legendConfig}
        />
    )
}

export default NivoSankeyChart